function Header() {
  return (
    <div className="header">
      <h1 className="title">NOTE WAVE</h1>
    </div>
  );
}

export default Header;
